import type { ResultsLegFragment } from '@websky/graphql';

import { buildDataAttributes } from '../dom/buildDataAttributes';

export function flightCardDataAttributes({
	testId,
	segments,
	flightIndex,
	selected,
	recommended,
	opened
}: {
	testId: 'flight' | 'mobile-flight';
	segments: ResultsLegFragment['segments'];
	flightIndex?: number;
	selected?: boolean;
	recommended?: boolean;
	opened?: boolean;
}): Record<string, string> {
	const flightId = segments.map(segment => segment.segment.id).join('-');

	return buildDataAttributes({
		'test-id': testId,
		'flight-id': flightId,
		'flight-index': flightIndex,
		selected: selected,
		recommended: recommended,
		opened: opened
	});
}
